import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  itemId: string;
  prompt: string;
  previousContent?: string;
};

type Result = {
  content: string;
};

const [useGenerateNoteContent, generateNoteContent] = createAsyncAction(
  "items/generateNoteContent",
  async ({ itemId, prompt, previousContent }: Args) =>
    await API.call<Result>({
      endpoint: `items/${itemId}/generate-content`,
      method: "POST",
      data: { prompt, previous_content: previousContent },
    })
);

export default useGenerateNoteContent;
export { generateNoteContent };
